import { Grid, Box, Typography, Link } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';

// Original class: ProjectWrap
const StyledProjectWrap = styled(Box)(theme => ({
  display: 'flex',
  padding: '20px',
  width: '100%',
  background: '#FFFFFF',
  borderRadius: '8px',
  flexDirection: 'column',
  boxShadow: '0px 5px 10px -8px #A0A1AA66',
}));
// Original class: projectTtl
const StyledProjectTtl = styled(Typography)(theme => ({
  cursor: 'pointer',
  overflowWrap: 'break-word',

  '&:hover': {
    textDecoration: 'underline',
  },
}));
// Original class: ProjectStatus
const StyledProjectStatus = styled('span')(theme => ({
  color: '#37C670',
}));
// Original class: projectFiledTtl
const StyledProjectFiledTtl = styled(Typography)(theme => ({
  color: '#41424E !important',
}));
// Original class: projectFiledValue
const StyledProjectFiledValue = styled(Typography)(theme => ({
  color: '#212346 !important',
  overflowWrap: 'break-word',
}));

const ProjectsTilesView = ({ projects }) => {
  return (
    <Grid spacing={5} container>
      {projects.map((project, index) => {
        const projectUrl = '/projects/' + project.services.redmineId;
        return (
          <Grid container key={index} size={3}>
            <StyledProjectWrap direction='column'>
              <Link
                href={projectUrl}
                sx={{
                  color: '#212346',
                }}
              >
                <StyledProjectTtl variant='h3'>
                  {project.rowName}{' '}
                  <StyledProjectStatus
                    sx={{
                      color:
                        project.services.status === '1' ? '#37C670' : '#E03737',
                    }}
                  >
                    •
                  </StyledProjectStatus>
                </StyledProjectTtl>
              </Link>
              {project.columns.map((field, index) =>
                field.fieldId != 'project.name' ? (
                  <Box
                    key={index}
                    sx={{
                      marginTop: '8px',
                    }}
                  >
                    <StyledProjectFiledTtl variant='h5'>
                      {field.fieldName}:
                    </StyledProjectFiledTtl>
                    <StyledProjectFiledValue variant='h5'>
                      {field.value}
                    </StyledProjectFiledValue>
                  </Box>
                ) : null,
              )}
            </StyledProjectWrap>
          </Grid>
        );
      })}
    </Grid>
  );
};
export default ProjectsTilesView;
